import { render, staticRenderFns } from "./DocumentViewModal.vue?vue&type=template&id=ad4aad3c&scoped=true"
import script from "./DocumentViewModal.vue?vue&type=script&lang=js"
export * from "./DocumentViewModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewModal.vue?vue&type=style&index=0&id=ad4aad3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4aad3c",
  null
  
)

export default component.exports